import styled from "styled-components"

export const Container = styled.div`
border: 0.1rem solid ${p => p.theme.colors.borderLight};
  border-radius: 0.6rem;
  padding: 1rem;
  margin: 2rem 0;

  h4 {
    margin: 0;
  }
`
